import * as types from '../actions/types'
import Immutable from 'immutable'
import diff from 'immutablediff'
import patch from 'immutablepatch'

import {
    isPrimitive,
    documento,
    getPorcentaje,
    solicitudservicioitem
} from '../utils/helpers'


const INITIAL_STATE = Immutable.fromJS({
    id: null,
    estado: 0,
	solicitud: {},
    btnSaveDisabled: true,
    btnRComprasDisabled: true,
    btnAproveDisabled: false,
    modified: [],
    modalCreateDocumento: {
		title: '',
		mode: '',
		show: false,
		data: null,
		btnDisabled: false,
        plantillas: [],
        garantias: [],
        unchanged: null,
        contratoanual: false,
        contratosAnuales: []
    },

    modalAddServicio: {
        show: false,
        title: '',
        mode: null,
        data: null,
        btnDisabled: false
    },

    aprobadores: [],

    addModificacion: false,

    comentario: {
        id: null,
        texto: null,
        btnSendDisabled: false
    }

})

export default function (state = INITIAL_STATE, action) {
    let i, p, data, index, cotizado
	switch (action.type) {
        case types.REINICIAR_SOLICITUD_SERVICIO_OT1:
            return INITIAL_STATE
        case types.ADICIONAR_MODIFICACION_SOLICITUD_SERVICIO_OT:
            state = state.set('modified', state.get('modified').filter(x => x.get('entity') + x.get('attribute') + x.get('id') !== action.payload.entity + action.payload.attribute + action.payload.id))
            state = state.update('modified', list => list.push(Immutable.fromJS(action.payload)))
            state = state.set('btnSaveDisabled', state.get('modified').count() === 0)
            return state
		case types.OBTENER_SOLICITUD_SERVICIO_OT:
			state = state.set('id', action.payload.solicitud.id)
			state = state.set('estado', action.payload.solicitud.estado)
            state = state.set('solicitud', Immutable.fromJS(action.payload.solicitud))
            state = state.set('unchaged', Immutable.fromJS(action.payload.solicitud))
            state = state.set('aprobadores', Immutable.fromJS(action.payload.aprobadores))
            if (action.payload.reset !== false) {
                state = state.set('modified', INITIAL_STATE.get('modified'))
            }
            state = state.set('btnSaveDisabled', state.get('modified').count() === 0)
			return state
        case types.ACTUALIZAR_SOLICITUD_SERVICIO_OT:
            const ops = diff(state.get('solicitud'), Immutable.fromJS(action.payload.solicitud))
            state = state.set('solicitud', patch(state.get('solicitud'), ops))
            if (ops.filter(x => x.get('path') === '/estado').count() === 1) {
                state = state.set('estado', state.getIn(['solicitud', 'estado']))
            }
            state = state.set('aprobadores', Immutable.fromJS(action.payload.aprobadores))
            state = state.set('btnRComprasDisabled', true)
            state = state.set('addModificacion', false)
            state = state.set('comentario', INITIAL_STATE.get('comentario'));

            return state


        case types.MOSTRAR_MODAL_CREAR_DOCUMENTO_SOLICITUD_SERVICIO_OT:

            state = state.setIn(['modalCreateDocumento', 'show'], action.payload.show)

            if (action.payload.show) {

                state = state.setIn(['modalCreateDocumento', 'title'], action.payload.title)
                state = state.setIn(['modalCreateDocumento', 'mode'], action.payload.mode)
                state = state.setIn(['modalCreateDocumento', 'plantillas'], Immutable.fromJS(action.payload.plantillas))
                state = state.setIn(['modalCreateDocumento', 'garantias'], Immutable.fromJS(action.payload.garantias))
                state = state.setIn(['modalCreateDocumento', 'contratosAnuales'], Immutable.fromJS(action.payload.contratos))



                if (action.payload.mode === 'create') {

                    const solicitud_id = state.get('id')
                    const documento_id = state.getIn(['solicitud', 'documentos', action.payload.indexDocumento, 'id'])
                    const proveedor_id = state.getIn(['solicitud', 'documentos', action.payload.indexDocumento, 'proveedor', 'id'])
                    state = state.setIn(['modalCreateDocumento', 'data'], Immutable.fromJS(documento(documento_id, solicitud_id, proveedor_id)))

                } else if (action.payload.mode === 'edit') {

                    state = state.setIn(['modalCreateDocumento', 'data'], state.getIn(['solicitud', 'documentos', action.payload.indexDocumento]))
                    state = state.setIn(['modalCreateDocumento', 'unchanged'], state.getIn(['solicitud', 'documentos', action.payload.indexDocumento]))
                    const tipo = state.getIn(['modalCreateDocumento', 'data', 'tipo'])


                    // console.log('consecutivo', state.getIn(['modalCreateDocumento', 'data']));
                    // console.log('consecutivo', state.getIn(['modalCreateDocumento', 'unchanged']));

                    const creado = state.getIn(['modalCreateDocumento', 'data', 'consecutivo']) ? true : false;
                    if (!creado) {
                        state = state.setIn(['modalCreateDocumento', 'data', 'entregas_parciales'], true)
                    }

                    const cotizado = state.getIn(['modalCreateDocumento', 'data', 'cotizacion', 'cotizado'])
                    const aiu_adm = state.getIn(['modalCreateDocumento', 'data', 'aiu_administracion'])
                    state = state.setIn(['modalCreateDocumento', 'data', 'aiu_administracion_value'], getPorcentaje(cotizado, aiu_adm) || 0)
                    const aiu_imp = state.getIn(['modalCreateDocumento', 'data', 'aiu_imprevistos'])
                    state = state.setIn(['modalCreateDocumento', 'data', 'aiu_imprevistos_value'], getPorcentaje(cotizado, aiu_imp) || 0)
                    const aiu_uti = state.getIn(['modalCreateDocumento', 'data', 'aiu_utilidad'])
                    state = state.setIn(['modalCreateDocumento', 'data', 'aiu_utilidad_value'], getPorcentaje(cotizado, aiu_uti) || 0)
                    const aiu_iva_uti = state.getIn(['modalCreateDocumento', 'data', 'aiu_iva_utilidad'])
                    state = state.setIn(['modalCreateDocumento', 'data', 'aiu_iva_utilidad_value'], getPorcentaje(state.getIn(['modalCreateDocumento', 'data', 'aiu_utilidad_value']), aiu_iva_uti) || 0)
                    const iva = state.getIn(['modalCreateDocumento', 'data', 'iva'])
                    state = state.setIn(['modalCreateDocumento', 'data', 'iva_value'], getPorcentaje(cotizado, iva) || 0)
                    const aiu_total = state.getIn(['modalCreateDocumento', 'data', 'aiu_administracion_value']) + state.getIn(['modalCreateDocumento', 'data', 'aiu_imprevistos_value'])
                        + state.getIn(['modalCreateDocumento', 'data', 'aiu_utilidad_value']) + state.getIn(['modalCreateDocumento', 'data', 'aiu_iva_utilidad_value']) +
                        state.getIn(['modalCreateDocumento', 'data', 'iva_value']) + cotizado
                    state = state.setIn(['modalCreateDocumento', 'data', 'aiu_total'], aiu_total)

                    if (!state.getIn(['modalCreateDocumento', 'data', 'fecha_inicio']))
                        state = state.setIn(['modalCreateDocumento', 'data', 'fecha_inicio'], state.getIn(['solicitud', 'created_at']))
                    if (!state.getIn(['modalCreateDocumento', 'data', 'fecha_entrega']))
                        state = state.setIn(['modalCreateDocumento', 'data', 'fecha_entrega'], state.getIn(['solicitud', 'fecha_requerido']))

                    // if (tipo == 4) {
                    //     const documento_original = state.getIn(['solicitud', 'documento_origen'])
                    //     state = state.setIn(['modalCreateDocumento', 'data', 'fecha_entrega'], documento_original.get('fecha_entrega'))
                    //     state = state.setIn(['modalCreateDocumento', 'data', 'fecha_inicio'], documento_original.get('fecha_inicio'))
                    // }

                    if (tipo == 5) {
                        state = state.setIn(['modalCreateDocumento', 'contratoanual'], true)
                    }

                    if (tipo == 4) {
                        state = state.setIn(['modalCreateDocumento', 'data', 'anticipo'], 0)
                    }

                }

            } else {
                state = state.set('modalCreateDocumento', INITIAL_STATE.get('modalCreateDocumento'))
            }

			return state
        case types.MODIFICAR_INPUTS_SOLICITUD_SERVICIO_OT1:

            if (isPrimitive(action.payload.value)) {
    			state = state.setIn(`${action.payload.path}`.split('.'), action.payload.value)
            } else {
                if (action.payload.immutable === false) {
                    state = state.setIn(`${action.payload.path}`.split('.'), action.payload.value)
                } else {
                    state = state.setIn(`${action.payload.path}`.split('.'), Immutable.fromJS(action.payload.value))
                }
            }


            if (action.payload.path == 'modalCreateDocumento.contratoanual') {
                state = state.setIn(['modalCreateDocumento', 'data', 'tipo'], 0)
                state = state.setIn(['modalCreateDocumento', 'data', 'plantilla_id'], 0)
                if (action.payload.value == false) {
                    state = state.setIn(['modalCreateDocumento', 'data', 'documento_id'], null)
                }
            }


            if (action.payload.path.split('.').slice(-1)[0] == 'responsable_compras' || action.payload.path.split('.').slice(-1)[0] == 'solicitante') {
                state = state.set('btnRComprasDisabled', false)
            }



            if (action.payload.path.split('.').slice(-1)[0] == 'aiu_administracion') {

                const cotizado = state.getIn(['modalCreateDocumento', 'data', 'cotizacion', 'cotizado'])
                const porcentaje = state.getIn(['modalCreateDocumento', 'data', 'aiu_administracion'])
                const valor = getPorcentaje(cotizado, porcentaje)

                state = state.setIn(['modalCreateDocumento', 'data', 'aiu_administracion_value'], valor)
            }



            if (action.payload.path.split('.').slice(-1)[0] == 'aiu_imprevistos') {

                const cotizado = state.getIn(['modalCreateDocumento', 'data', 'cotizacion', 'cotizado'])
                const porcentaje = state.getIn(['modalCreateDocumento', 'data', 'aiu_imprevistos'])
                const valor = getPorcentaje(cotizado, porcentaje)

                state = state.setIn(['modalCreateDocumento', 'data', 'aiu_imprevistos_value'], valor)
            }


            if (action.payload.path.split('.').slice(-1)[0] == 'aiu_utilidad') {

                const cotizado = state.getIn(['modalCreateDocumento', 'data', 'cotizacion', 'cotizado'])
                const porcentaje = state.getIn(['modalCreateDocumento', 'data', 'aiu_utilidad'])
                const valor = getPorcentaje(cotizado, porcentaje)

                state = state.setIn(['modalCreateDocumento', 'data', 'aiu_utilidad_value'], valor)

            }



            if (action.payload.path.split('.').slice(-1)[0] == 'aiu_iva_utilidad' || action.payload.path.split('.').slice(-1)[0] == 'aiu_utilidad') {

                const utilidad = state.getIn(['modalCreateDocumento', 'data', 'aiu_utilidad_value'])
                const porcentaje = state.getIn(['modalCreateDocumento', 'data', 'aiu_iva_utilidad'])
                const valor = getPorcentaje(utilidad, porcentaje)

                state = state.setIn(['modalCreateDocumento', 'data', 'aiu_iva_utilidad_value'], valor)

            }

            if (action.payload.path.split('.').slice(-1)[0] == 'iva') {

                const cotizado = state.getIn(['modalCreateDocumento', 'data', 'cotizacion', 'cotizado'])
                const porcentaje = state.getIn(['modalCreateDocumento', 'data', 'iva'])
                const valor = getPorcentaje(cotizado, porcentaje)

                state = state.setIn(['modalCreateDocumento', 'data', 'iva_value'], valor)

            }

            if (state.getIn(['modalCreateDocumento', 'data'])) {
                const aiu_administracion_value = state.getIn(['modalCreateDocumento', 'data', 'aiu_administracion_value'])
                const aiu_imprevistos_value = state.getIn(['modalCreateDocumento', 'data', 'aiu_imprevistos_value'])
                const aiu_utilidad_value = state.getIn(['modalCreateDocumento', 'data', 'aiu_utilidad_value'])
                const aiu_iva_utilidad_value = state.getIn(['modalCreateDocumento', 'data', 'aiu_iva_utilidad_value'])
                const iva = state.getIn(['modalCreateDocumento', 'data', 'iva_value'])
                const cotizado = state.getIn(['modalCreateDocumento', 'data', 'cotizacion', 'cotizado'])
                const aiu_total = aiu_administracion_value + aiu_imprevistos_value + aiu_utilidad_value + aiu_iva_utilidad_value + iva + cotizado
                state = state.setIn(['modalCreateDocumento', 'data', 'aiu_total'], aiu_total)
                // state = state.setIn(['modalCreateDocumento', 'data', 'cotizacion', 'cotizado_iva'], cotizado + aiu_total)

                if (action.payload.path.split('.').slice(-1)[0] == 'tipo') {
                    state = state.setIn(['modalCreateDocumento', 'data', 'plantilla_id'], 0)
                }

                if (action.payload.path.split('.').slice(-1)[0] == 'contratoanual') {
                    state = state.setIn(['modalCreateDocumento', 'data', 'documento_id'], null)
                    state = state.setIn(['modalCreateDocumento', 'data', 'tipo'], 0)
                    state = state.setIn(['modalCreateDocumento', 'data', 'plantilla_id'], -1)
                    state = state.setIn(['modalCreateDocumento', 'data', 'consecutivo'], '')
                }

            }


            // if (action.payload.path.split('.').slice(-1)[0] == 'rubro_id') {
            //     let newPath = action.payload.path.split('.')
            //     newPath = newPath.splice(0, newPath.length-1)
            //     if (newPath[newPath.length-1] == 'pivot') {
            //         state = state.setIn([...newPath, 'selected'], true)
            //     }
            // }



            return state

        case types.REINICIAR_VALORES_AIU:
            cotizado = state.getIn(['modalCreateDocumento', 'data', 'cotizacion', 'cotizado'])
            state = state.setIn(['modalCreateDocumento', 'data', 'aiu_administracion'], 0)
            state = state.setIn(['modalCreateDocumento', 'data', 'aiu_administracion_value'], 0)
            state = state.setIn(['modalCreateDocumento', 'data', 'aiu_imprevistos'], 0)
            state = state.setIn(['modalCreateDocumento', 'data', 'aiu_imprevistos_value'], 0)
            state = state.setIn(['modalCreateDocumento', 'data', 'aiu_utilidad'], 0)
            state = state.setIn(['modalCreateDocumento', 'data', 'aiu_utilidad_value'], 0)
            state = state.setIn(['modalCreateDocumento', 'data', 'aiu_iva_utilidad'], 0)
            state = state.setIn(['modalCreateDocumento', 'data', 'aiu_iva_utilidad_value'], 0)
            state = state.setIn(['modalCreateDocumento', 'data', 'aiu_total'], cotizado)

            return state

        case types.REINICIAR_VALORES_IVA:
            cotizado = state.getIn(['modalCreateDocumento', 'data', 'cotizacion', 'cotizado'])
            state = state.setIn(['modalCreateDocumento', 'data', 'iva'], 0)
            state = state.setIn(['modalCreateDocumento', 'data', 'aiu_total'], cotizado)
            return state

        case types.ADICIONAR_GARANTIA_DOCUMENTO_SOLICITUD_SERVICIO_OT:
            const garantia = state.getIn(['modalCreateDocumento', 'garantias', String(action.payload)])
            state = state.updateIn(['modalCreateDocumento', 'data', 'garantias'], list => list.push(garantia))
            return state
        case types.REMOVER_GARANTIA_DOCUMENTO_SOLICITUD_SERVICIO_OT:
            state = state.setIn(['modalCreateDocumento', 'data', 'garantias'], state.getIn(['modalCreateDocumento', 'data', 'garantias']).filter(x => x.get('id') !== action.payload))
            return state
        case types.ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_SERVICIO_OT1:
            data = action.payload
            index = state.getIn(['solicitud','adjuntos']).findIndex(x => x.get('guid') === data.get('guid'))
            data = data.set('nombre', `${data.get('nombre')}`)
            if (index === -1) {
                state = state.setIn(['solicitud','adjuntos'], state.getIn(['solicitud','adjuntos']).push(data))
            } else {
                state = state.setIn(['solicitud','adjuntos',String(index)], data)
            }
            return state
        case types.ELIMINAR_ARCHIVOS_SOLICITUD_SERVICIO_OT1:
            state = state.updateIn(['solicitud', 'adjuntos'], list => list.filter(x => !x.get('selected')))
            return state



        case types.DESHABILITAR_BOTON_MODAL_CREAR_DOCUMENTO_SOLICITUD_SERVICIO_OT:
            state = state.setIn(['modalCreateDocumento', 'btnDisabled'], action.payload)
            return state


        case types.DESHABILITAR_BOTONES_APROBACION_SOLICITUD_SERVICIO_OT:
            state = state.set('btnAproveDisabled', action.payload)
            return state


        case types.MOSTRAR_MODAL_AGREGAR_SERVICIO_OT_SOLICITUD_SERVICIO_OT1:

            state = state.setIn(['modalAddServicio', 'title'], action.payload.title)
            state = state.setIn(['modalAddServicio', 'show'], action.payload.show)
            state = state.setIn(['modalAddServicio', 'mode'], action.payload.mode)
            data = Immutable.fromJS(solicitudservicioitem())

			if (action.payload.mode === 'edit') {
                data = state.getIn(['solicitud', 'servicios', String(action.payload.index)])
			}
            state = state.setIn(['modalAddServicio', 'data'], data)
            return state


        case types.OCULTAR_MODAL_AGREGAR_SERVICIO_OT_SOLICITUD_SERVICIO_OT1:
            state = state.set('modalAddServicio', INITIAL_STATE.get('modalAddServicio'))
            return state

        case types.ADICIONAR_NUEVO_ITEM_SOLICITUD_SERVICIO_OT1:
            data = state.getIn(['modalAddServicio', 'data'])
            const mode = state.getIn(['modalAddServicio', 'mode'])
            if (mode == 'create') {
                state = state.setIn(['solicitud', 'servicios'], state.getIn(['solicitud', 'servicios']).push(data))
            }
            if (mode == 'edit') {
                index = state.getIn(['solicitud', 'servicios']).findIndex(x => ((data.get('guid') && x.get('guid') === data.get('guid')) || x.get('id') === data.get('id')))
                if (index >= 0) {
                    state = state.setIn(['solicitud', 'servicios', String(index)], data)
                }
            }
            state = state.set('addModificacion', true)
			return state


        case types.SELECCIONAR_MONEDA_SOLICITUD_OT1:
            var idx = 0;
            if (state.getIn(['solicitud','cotizaciones'])) {
                for(idx = 0; idx < state.getIn(['solicitud','cotizaciones']).count(); idx++) {
                    state = state.setIn(['solicitud','cotizaciones',idx,'moneda'], action.payload.moneda)
                }
            }
            state = state.set('addModificacion', true)
            return state


        case types.EDITAR_COMENTARIO_SOLICITUD_OT1:
            index = state.getIn(['solicitud','foros']).findIndex(c => c.get('id') === action.payload.id)
            state = state.setIn(['comentario','id'], action.payload.id)
            state = state.setIn(['comentario','texto'], state.getIn(['solicitud', 'foros', index, 'comentario']))
            return state

        case types.DESHABILITAR_BOTON_ENVIAR_COMENTARIO_OT1:
            state = state.setIn(['comentario','btnSendDisabled'], action.payload)
            return state

        case types.ENVIAR_ACTUALIZAR_COMENTARIO_SOLICITUD_OT1:
            state = state.setIn(['solicitud','foros'], Immutable.fromJS(action.payload.foros))
            state = state.set('comentario', INITIAL_STATE.get('comentario'));
            return state


        default:
            return state


	}
}



// WEBPACK FOOTER //
// ./src/reducers/solicitudservicioot.js